import React from 'react';
import {
    Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Container
} from 'reactstrap';

function PokeGame({ wildPokemonID, timeLeft, gameStarted, isLoading }) {
    return (
        <Container style={{ color: "black" }}>
            {gameStarted ?
                <Card>
                    <CardBody>
                        <CardTitle className='text-center' style={{ fontSize: '18px' }}><strong>Guess the pokemon!</strong></CardTitle>
                        <CardSubtitle className='text-center'>{timeLeft}</CardSubtitle>
                    </CardBody>
                    {isLoading ? <img height="300px" src="./wobble.gif" /> :
                        <CardImg height="300px" src={"https://pokeres.bastionbot.org/images/pokemon/" + wildPokemonID + ".png"} alt="Loading.." />
                    }
                </Card> :
                <Card>
                    <CardBody>
                        <CardTitle className='text-center' style={{ fontSize: '18px' }}><strong>Rules</strong></CardTitle>
                        <br></br>
                        <CardSubtitle className='text-center'>
                            <i>1. Minimum 2 players are required to play the game.</i>
                            <br></br>
                            <i>2. <strong>Do not use headphones.</strong> Audio still in development.</i>
                            <br></br>
                            <i>3. Kindly wait for a few seconds until you get an admin generated message.</i>
                            <br></br>
                            <i>4. The Host can choose the Generation, number of Pokemons and time for each round.</i>
                            <br></br>
                            <i>5. Use the chat box to guess the Pokemon's name and to chat with other people in the room.</i>
                            <br></br>
                            <i>6. Use hyphen to join words if Pokemon's name is more than 1 word.</i>
                            <br></br>
                            <i>7. Refresh the browser and you are <strong>kicked out!</strong></i>
                        </CardSubtitle>
                    </CardBody>
                </Card>
            }
        </Container>
    );
}
export default PokeGame;
